import React from 'react';

import { InteractivePropType } from 'propTypes/common';

import UpturnCard from './components/UpturnCard';

import styles from './styles.module.scss';

const UpturnCards = ({ interactive }) => {
	const { upturnCards } = interactive;

	return upturnCards?.length ? (
		<div className={styles.UpturnCards}>
			{upturnCards.map((card) =>
				card.back && card.front ? (
					<UpturnCard
						key={card.back.file?._id || card.front.file?._id}
						backCard={card.back}
						frontCard={card.front}
					/>
				) : null
			)}
		</div>
	) : null;
};

UpturnCards.propTypes = {
	interactive: InteractivePropType
};

export default UpturnCards;
